import { TFunction } from "next-i18next";

import { PageContentProps } from "content/content.types";

import defaultContent from "./common";

export default (t: TFunction, pageContent: PageContentProps) =>
    defaultContent(t, pageContent);
